/**
 * File d'attente limitant le nombre de requêtes lancées simultanément
 * Le recalcul d'une journée déclenche plusieurs centaines d'appels : sans limite,
 * le navigateur les met en file lui-même et l'API peut les rejeter en masse
 */
export const MAX_CONCURRENT_REQUESTS = 8;

let runningRequests = 0;
const waitingRequests = [];

const runNextRequest = () => {
  if (runningRequests >= MAX_CONCURRENT_REQUESTS || waitingRequests.length === 0) {
    return;
  }

  const { task, resolve, reject } = waitingRequests.shift();
  runningRequests += 1;

  Promise.resolve()
    .then(task)
    .then(resolve, reject)
    .finally(() => {
      runningRequests -= 1;
      runNextRequest();
    });
};

/**
 * Exécute une tâche dès qu'une place se libère dans la file
 * @param {Function} task la tâche renvoyant une promesse
 * @returns {Promise} le résultat de la tâche
 */
export const enqueueRequest = (task) => {
  return new Promise((resolve, reject) => {
    waitingRequests.push({
      task,
      resolve,
      reject,
    });
    runNextRequest();
  });
};